import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLang } from "@/i18n";

export const WhatsAppFab = () => {
  const { t } = useLang();
  const [pulse, setPulse] = useState(false);

  // Pulse once when the contact section first becomes visible.
  useEffect(() => {
    const on = () => {
      setPulse(true);
      setTimeout(() => setPulse(false), 2600);
    };
    window.addEventListener("ag:contact-visible", on);
    return () => window.removeEventListener("ag:contact-visible", on);
  }, []);

  return (
    <a
      href="https://wa.me/393397966579"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label={t.contact.whatsapp}
      className="fixed bottom-6 right-6 z-[55] group flex items-center gap-3"
    >
      <span className="hidden md:block font-mono2 text-[10px] tracking-[0.25em] uppercase text-[var(--txt-dim)] bg-black/50 backdrop-blur-md border border-white/10 px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        {t.contact.whatsapp}
      </span>
      <span className="relative h-14 w-14 shrink-0">
        {pulse && (
          <motion.span
            aria-hidden
            className="absolute inset-0 rounded-full bg-[var(--accent)]"
            initial={{ scale: 1, opacity: 0.5 }}
            animate={{ scale: [1, 2.2], opacity: [0.5, 0] }}
            transition={{ duration: 1.3, ease: "easeOut", repeat: 1 }}
          />
        )}
        <motion.span
          animate={pulse ? { scale: [1, 1.14, 1] } : {}}
          transition={{ duration: 0.6, ease: "easeInOut", repeat: pulse ? 2 : 0 }}
          className="relative h-14 w-14 rounded-full bg-[var(--accent)] text-black flex items-center justify-center shadow-lg shadow-black/40 group-hover:scale-105 active:scale-95 transition-transform duration-300"
        >
          <MessageCircle className="h-6 w-6" strokeWidth={1.8} />
        </motion.span>
      </span>
    </a>
  );
};
